import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { models } from '../modele/modele-form';


@Component({
  selector: 'app-rce',
  templateUrl: './rce.component.html',
  styleUrls: ['./rce.component.scss']
})
export class RceComponent implements OnInit {

  // Navigation et état
  currentStep = 0;
  totalSteps = 6;
  
  // Formulaires
  entreprise1Form: FormGroup;
  entreprise2Form: FormGroup;
  pieceJointeForm: FormGroup;
  
  // États de l'interface
  loader: boolean = false;
  sendingRequest: boolean = false;
  
  // Configuration
  newDate = new Date();
  
  // Références
  numeroSous: string;
  refPro: string;
  
  // Listes de données
  listStatutJuridique = [
    {id: 'CONC', name: "GIE"},
    {id: 'DEVP', name: "Projet de développement"},
    {id: 'DIPR', name: "Représentant diplomatique / Organisation International"},
    {id: 'ENTE', name: "SA"},
    {id: 'LIBP', name: "Profession Libérale"},
    {id: 'LOCE', name: "SARL"},
    {id: 'PHYP', name: "SUARL"},
    {id: 'PUB', name: "Société en commandite"},
    {id: 'PUBP', name: "Etablissement publique et parapublique"},
    {id: 'PVT', name: 'Association / Coopérative'}
  ];

  // Gestion des fichiers
  nomFile: string = "";
  noImage: string = "assets/images/upload.png";
  downloadIcon = "assets/images/file.png";
  downloadFile: boolean = true;
  typeProduitList: any;

  // Interface utilisateur
  title = "";
  userConnecter: any;

   // Données slide pour le banner
  slideData;
  lien = "";
  informations;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private utilsService: UtilsService,
    private rechercheService: SubscriptionService
  ) {
    // Initialisation des références
    let time = new Date().getTime();
    let pro = new Date().getTime() + 123890989;
    this.numeroSous = "SN" + time + "RCE";
    this.refPro = "SN" + pro + "PR";

    // Récupération des informations utilisateur
    this.userConnecter = JSON.parse(localStorage.getItem('microFinance') || '{}');
    // Récupération des informations utilisateur
    // @ts-ignore
    let lienBrute: String = this.route.snapshot._routerState.url;
    this.lien = lienBrute.substring(1, lienBrute.length);
    this.informations = models[this.lien];
    this.userConnecter = JSON.parse(localStorage.getItem('microFinance') || '{}');
    localStorage.setItem('sectionShown', this.lien);
    this.slideData = [{
        title: 'Inclusive Market',
        subTitle: "Toutes vos assurances en 1 seul endroit",
        description: "Votre devis gratuit personnalisé en quelques clics",
        imgBackground: "assets/images/slide-mrp.png",
        type: "ASSURANCE RESPONSABLITE CIVIL ENTREPRISE",
        imgIcon: "assets/images/foreman-green.svg",
        img: 'assets/images/slide-mrp.png'
    }];
  }

  ngOnInit() {
    this.initializeForm();
    this.loadTypeProduit();
  }

  // Initialisation des formulaires
  initializeForm() {
    this.entreprise1Form = this.fb.group({
      raisonSocial: ['', Validators.required],
      adresse: ['', Validators.required],
      formeJuridique: ['', Validators.required],
      activiteEntreprise: ['', Validators.required],
      dateExploitation: ['', Validators.required],
      chiffreAffaire: ['', Validators.required],
      chiffreAffairePreci: ['', Validators.required],
      masseSalarial: ['', Validators.required],
      masseSalarialPreci: ['', Validators.required],
      nbrPersonnel: ['', Validators.required],
      clientList: ['', Validators.required]
    });

    this.entreprise2Form = this.fb.group({
      travaux: ['', Validators.required],
      descriptionAppareil: [''],
      locataireOrProprietaire: ['', Validators.required],
      entrepose: ['', Validators.required],
      matiere: [''],
      autreDeclaration: ['']
    });

    this.pieceJointeForm = this.fb.group({
      file: ['', Validators.required]
    });
  }

  // Navigation entre étapes
  nextStep() {
    if (this.currentStep === 4) {
      if (!this.valideFile()) {
        return;
      }
      this.currentStep = 5;
      return;
    }
    
    if (this.isCurrentStepValid()) {
      if (this.currentStep < 5) {
        this.currentStep++;
        setTimeout(() => window.scrollTo({ top: 500, behavior: 'smooth' }), 100);
      }
    } else {
      this.markFormGroupTouched();
      this.toastr.warning("Veuillez remplir tous les champs obligatoires", "Attention");
    }
  }

  previousStep() {
    if (this.currentStep > 0) {
      this.currentStep--;
      window.scrollTo(0, 0);
    }
  }

  // Validation des étapes
  isCurrentStepValid(): boolean {
    switch (this.currentStep) {
      case 1:
        return this.entreprise1Form.get('raisonSocial')?.valid &&
               this.entreprise1Form.get('adresse')?.valid &&
               this.entreprise1Form.get('formeJuridique')?.valid &&
               this.entreprise1Form.get('activiteEntreprise')?.valid &&
               this.entreprise1Form.get('dateExploitation')?.valid;
      case 2:
        return this.entreprise1Form.get('chiffreAffairePreci')?.valid &&
               this.entreprise1Form.get('masseSalarialPreci')?.valid &&
               this.entreprise1Form.get('nbrPersonnel')?.valid &&
               this.entreprise1Form.get('chiffreAffaire')?.valid &&
               this.entreprise1Form.get('masseSalarial')?.valid &&
               this.entreprise1Form.get('clientList')?.valid;
      case 3:
        return this.entreprise2Form.get('travaux')?.valid &&
               this.entreprise2Form.get('locataireOrProprietaire')?.valid &&
               this.entreprise2Form.get('entrepose')?.valid;
      case 4:
        return this.pieceJointeForm.get('file')?.valid;
      default:
        return true;
    }
  }

  valideFile() {
    if (this.pieceJointeForm.get('file')?.invalid) {
      this.toastr.error("Veuillez joindre le questionnaire RCE");
      return false;
    }
    return true;
  }

  markFormGroupTouched() {
    const currentForm = this.getCurrentForm();
    if (currentForm) {
      Object.keys(currentForm.controls).forEach(key => {
        const control = currentForm.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
    }
  }

  getCurrentForm(): FormGroup | null {
    switch (this.currentStep) {
      case 1:
      case 2:
        return this.entreprise1Form;
      case 3:
        return this.entreprise2Form;
      case 4:
        return this.pieceJointeForm;
      default:
        return null;
    }
  }

  // Chargement des données
  loadTypeProduit() {
    this.rechercheService.listProduit().subscribe(response => {
      if (response['responseCode'] === 200) {
        this.typeProduitList = response['data'].find((el: any) => 
          el.code === 'ASSURANCE_RCE'
        );        
      }
    });
  }

  // Gestion des fichiers
  selectOnFile(evt: any, type?: string, name?: string) {
    this.nomFile = name || 'Fichier sélectionné';
    this.loader = true;
    
    const accept = ['.doc', '.DOC', '.docx', '.DOCX', '.docm', '.DOCM', '.pdf', '.PDF', 
                   '.xls', '.XLS', '.xlsx', '.XLSX', '.png', '.PNG', '.jpg', '.JPG', '.jpeg', '.JPEG'];
    
    for (const file of evt.target.files) {  
      const index = file.name.lastIndexOf(".");
      const strsubstring = file.name.substring(index, file.name.length);
      let ext = strsubstring;
      if (accept.indexOf(strsubstring) === -1) {
        this.loader = false;
        this.toastr.error(`Ce fichier ${file.name} n'est pas au format autorisé`, 'Erreur');
        evt.target.value = '';
        return;
      } else {
        this.loader = true;
        const reader = new FileReader();
        
        reader.onload = (e: any) => {
          const docBase64Path = e.target.result;
          if (type) {
            this[type + '_VALUE'] = docBase64Path;
          }
          let image = '';
          if (ext === '.doc' || ext === '.DOC' || ext === '.docx' || ext === '.DOCX' || ext === '.docm' || ext === '.DOCM') {
            image = 'assets/images/doc.png';
            this.noImage = 'assets/images/doc.png';
          }
          else if (ext === '.pdf' || ext === '.PDF') {
            image = 'assets/images/pdf.png';
            this.noImage = 'assets/images/pdf.png';
          }
          else if (ext === '.xlsx' || ext === '.XLSX' || ext === '.xls' || ext === '.XLS') {
            image = 'assets/images/excel.png';
            this.noImage = 'assets/images/excel.png';
          }
          else {
            image = docBase64Path;
            this.noImage = docBase64Path;
          }
          this.saveFile1(file);
        };
        reader.readAsDataURL(file);
      }
    }
  }

  saveFile1(file: File) {
    this.loader = true;
    let dataFile = new FormData();

    dataFile.append('files', file);
    
    this.rechercheService.saveFile(dataFile).subscribe(
      resp => {
        if (resp) {
          this.loader = false;
          this.toastr.success("Fichier chargé avec succès", 'Succès');
          this.pieceJointeForm.get('file')?.setValue(resp['urlprod']);
        }
      }, 
      error => {
        this.loader = false;
        this.noImage = "assets/images/upload.png";
        this.nomFile = "";
        const errorMessage = error?.error?.errors?.[0]?.message || 
                            error?.error?.message || 
                            "Erreur lors du chargement du fichier";
        
        this.toastr.error(errorMessage, 'Erreur');
        this.pieceJointeForm.get('file')?.setValue('');
        //@ts-ignore
        evt.target.value = '';
      }
    );
  }

  downloadModel() {
    if (this.typeProduitList?.questionnaireUrl) {
      window.open(this.typeProduitList.questionnaireUrl, '_blank');
    } else {
      window.open('/assets/fileDownload/questionnaire_rce_default.pdf', '_blank');
    }
    this.downloadFile = false;
  }

  // Sauvegarde des données
  saveData() {
    this.sendingRequest = true;
    this.loader = true;
    
    const finalData = {
      ...this.entreprise1Form.value,
      ...this.entreprise2Form.value,
      pieceJointe: this.pieceJointeForm.value,
      numeroSous: this.numeroSous,
      refPro: this.refPro
    };

    const submissionData = {
      designationClient: this.userConnecter?.infos?.firstName + ' ' + this.userConnecter?.infos?.lastName,
      telephone: this.userConnecter?.infos?.telephone,
      email: this.userConnecter?.infos?.email,
      adresse: this.userConnecter?.infos?.adresse,
      typeRisque: "RCE",
      content: JSON.stringify(finalData)
    };
    
    this.rechercheService.saveSouscriptionOffline(submissionData)
      .subscribe(response => {
        if (response['responseCode'] == 200) {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.success("Demande de souscription RCE enregistrée avec succès");
          this.currentStep = this.totalSteps; // Étape succès
        } else {
          this.sendingRequest = false;
          this.loader = false;
          this.toastr.error(response['cause'].erreurs[0].message);
        }
      }, errors => {
        this.sendingRequest = false;
        this.loader = false;
        const errorMessage = errors['error']['cause'].erreurs ? 
          errors['error']['cause'].erreurs[0].message : 
          errors['error']['cause']['message'];
        this.toastr.error(errorMessage);
      });
  }

  // Utilitaires
  getFormeJuridiqueLabel(id: string): string {
    const forme = this.listStatutJuridique.find(f => f.id === id);
    return forme ? forme.name : id;
  }

  resetForm() {
    this.currentStep = 0;
    this.entreprise1Form.reset();
    this.entreprise2Form.reset();
    this.pieceJointeForm.reset();
    this.nomFile = "";
    this.noImage = "assets/images/upload.png";
    window.scrollTo(0, 0);
  }
}